<template>
  <Category v-if="isCategory" :info="page" />
  <Article v-else :page="page" />
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import Article from '../../../components/Blog/Article';
import Category from '../../../components/Blog/Category';

export default {
  components: { Article, Category },
  mixins: [global],
  layout: 'default',
  async asyncData({
    $axios, route, $config, error, redirect, store,
  }) {
    if (route.path.includes('/q/')) {
      const { link } = await $axios.$get(route.path);
      if (link) {
        return redirect(link);
      }
    }

    // Redirect old Q&A question URLs to new ones only if they are found
    if (route.path.includes('dwqa-answer')) {
      const newUrl = (route.path.split('dwqa-answer/answer-for-').pop() || '').slice(0, -1);

      const questionInfo = await $axios.$get(
        `/qa-hub/questions/${newUrl}?ab-test=${Date.now()}`,
      ).catch(() => false);

      if (questionInfo) {
        return redirect(301, `/question/${newUrl}`);
      }
    }

    let isCategory = true;
    let page = {};

    page = await $axios.$get(
      `/blog/categories/${route.params.blogSubItem}`,
      { noError: true },
    ).catch(() => false);

    if (!page) {
      isCategory = false;
      page = await $axios.$get(
        `/blog/posts/${route.params.blogSubItem}?slug=1&ab-test=${Date.now()}`,
      ).catch(() => false);

      if (page.categorySlug !== route.params.blogCategory) {
        return error({ statusCode: 404, message: 'Article not found' });
      }

      if (Object.keys(page.tests || {}).length) {
        store.dispatch('tests/addUserTests', page.tests);
      }
    } else {
      const seo = await $axios.$get(`/pages/${page.slug}`).catch(() => false);
      page.categoryId = page.id;
      Object.assign(page, seo);

      if (page.parentSlug !== route.params.blogCategory) {
        return error({ statusCode: 404, message: 'Category not found' });
      }
    }

    if (!page) {
      return error({ statusCode: 404, message: 'Category not found' });
    }

    page.fullPath = `${$config.siteUrl}${route.fullPath}`;
    page.slug = route.params.blogSubItem;
    page.blueFont = true;

    return {
      page,
      isCategory,
    };
  },
  head() {
    return {
      script: [
        {
          src: 'https://ccf26a.365datascience.com/app/js/api.min.js', async: true, type: 'text/javascript', 'data-account': '86498', 'data-user': '76915', 'data-api': 'acf268',
        },
      ],
    };
  },
};
</script>
